export const MAP_SCALE_WIDTH_FACTOR = 540.5;
export const MAP_SCALE_HEIGHT_FACTOR = 235.19;
export const MAP_SCALE_FACTOR = 95;

export const ANTARCTICA_ID = '010';
export const FR_S_ANTARCTIC_LANDS_ID = '260';
export const OMITTED_TERRITORIES = [ANTARCTICA_ID, FR_S_ANTARCTIC_LANDS_ID];
export const GRATICULE_STEP = [30, 30];

export const COUNTRIES_STANDARIZATION = {
  "Cote d'Ivoire": "Côte d'Ivoire",
  Laos: 'Lao PDR',
};
